import { render, staticRenderFns } from "./CorporatePhilosophy.vue?vue&type=template&id=dd0aca84"
import script from "./CorporatePhilosophy.vue?vue&type=script&lang=js"
export * from "./CorporatePhilosophy.vue?vue&type=script&lang=js"
import style0 from "./CorporatePhilosophy.vue?vue&type=style&index=0&id=dd0aca84&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports